/* 🤖 this file was generated by script */
export const wiconEdit01 = {
  name: 'edit_01',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.88 18.12c.04-.42.06-.62.13-.82a2 2 0 01.23-.48c.11-.17.26-.32.55-.61L17 3a2.83 2.83 0 114 4L7.8 20.2c-.3.3-.45.45-.62.56a2 2 0 01-.48.23c-.2.07-.4.09-.82.13l-3.38.38.38-3.38z"/></svg>`,
};
